import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../services/jrni/api.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  constructor(
    private apiService: ApiService
  ) { }

  resetPath: string = '';
  passwordResetForm: FormGroup;
  emailRegex = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
  shouldShowPasswordReset: boolean = false;
  resetError: boolean = true;
  resetSubmitted: boolean = false;
  resetSuccess: boolean = false;
  @Input() selectedDepartment: any;

  resetPasswordForm: FormGroup = new FormGroup({
    resetemail: new FormControl('', [Validators.required, Validators.pattern(this.emailRegex)]),
  });

  get resetForm() { return this.passwordResetForm.controls; }

  ngOnInit(): void {
    let staging = ""
     if (window.location.href.includes("staging") || window.location.href.includes("localhost")) {
      staging = "STAGING"
    }
    this.resetPath = `/?client=wrwa&environment=hwrc${staging}#/update-password`;
    if (this.resetPath.length < 1) {
      console.warn(`Password reset is unavailable - config.myCeremony.access.passwordResetPath is not set.`);
    }
    else {
      this.buildPasswordResetForm();
    }
  }

  buildPasswordResetForm() {
    this.passwordResetForm = new FormGroup({});
    const emailControl = new FormControl('', [Validators.required, Validators.email]);
    this.passwordResetForm.addControl('email', emailControl);

    this.passwordResetForm.valueChanges.subscribe(values => {
      console.log(values);
      console.log(this.passwordResetForm);
    });
  }

  toggleResetForm() {
    this.shouldShowPasswordReset = !this.shouldShowPasswordReset;
    this.resetError = false;
    if (this.resetSuccess) {
      this.resetSuccess = false;
    }
    if (this.resetSubmitted) {
      this.resetSubmitted = false;
    }
    this.resetForm.email.reset();
    return false;
  }

  async submitPasswordReset() {
    this.resetSubmitted = true;
    if (this.passwordResetForm.valid) {
      this.resetSubmitted = false;
      this.resetError = false;
      try {
        const sent:any = await this.apiService.passwordResetTokenBased(this.resetForm['email'].value, this.selectedDepartment.id, this.resetPath);
        if (sent.result && sent.result === 'Success') {
          this.resetSuccess = true;
        }
        else {
          this.resetError = true;
        }
      }
      catch (err) {
        this.resetError = true;
      }
      
    }
    else {
      console.log(this.passwordResetForm);
    }
  }

}
